import type { StudioResource } from '../studioResources';
import { buildCourseMaterialPath } from '../constants/courseStudioRoutes';
import { buildStudioMaterialUrl } from '../constants/studioMaterialRoutes';
import { buildPrintWorksheetUrl } from '../print/buildPrintWorksheetUrl';

export function resourceKey(resource: StudioResource): string {
  return `${resource.kind}:${resource.id}`;
}

/** Editor canónico: estudio print+chat. Clase interactiva sigue en material builder. */
export function editHref(
  resource: StudioResource,
  subjectId: string,
  courseId?: string,
): string {
  if (resource.kind === 'guide' || resource.kind === 'exam') {
    return buildPrintWorksheetUrl(resource.id, { edit: true });
  }
  if (resource.kind === 'class') {
    return buildStudioMaterialUrl({
      profile: 'interactive_class',
      subjectId,
      examId: resource.id,
      ...(courseId ? { courseId } : {}),
    });
  }
  const activityPath = `/studio/${resource.mode}?draft=${resource.id}&subject=${subjectId}`;
  return courseId ? buildCourseMaterialPath(courseId, activityPath) : activityPath;
}
